export default __webpack_public_path__ + "static/media/BNIcon-pink.59c07939.png";